import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Divider, Form, Grid, Segment } from 'semantic-ui-react'
import OrganizationDropdown from '../../OrganizationDropdown'

export const DEFAULT_EMPLOYMENT = {
  title: '',
  organization: {},
  isCurrent: false,
}

const Employment = ({ employment, onChange }) => {
  const { title, organization, isCurrent } = employment
  return (
    <>
      <Form.Group>
        <Form.Input
          width={8}
          label="Job Title"
          placeholder="Job Title"
          value={title}
          onChange={(e, { value }) => onChange({ ...employment, title: value })}
        />
        <OrganizationDropdown
          organization={organization}
          setOrganization={(updater) => {
            const nextOrg =
              typeof updater === 'function' ? updater(organization) : updater
            onChange({ ...employment, organization: nextOrg })
          }}
        />
      </Form.Group>
      <Form.Checkbox
        label="Currently works here"
        checked={isCurrent}
        onChange={(e, { checked }) =>
          onChange({ ...employment, isCurrent: checked })
        }
      />
    </>
  )
}

const EmploymentHistory = ({ employmentHistory, setEmploymentHistory }) => {
  const [employmentForms, setEmploymentForms] = useState(
    employmentHistory.map((e) => ({ id: uuidv4(), ...e }))
  )

  const syncEmploymentHistory = (forms) => {
    setEmploymentForms(forms)
    const clean = forms.map(({ id, ...rest }) => rest)
    setEmploymentHistory(clean)
  }

  const updateEmploymentAtIndex = (index, newEmployment) => {
    const updated = [...employmentForms]
    updated[index] = { ...newEmployment, id: updated[index].id }
    syncEmploymentHistory(updated)
  }

  const addEmployment = () => {
    syncEmploymentHistory([
      { ...DEFAULT_EMPLOYMENT, id: uuidv4() },
      ...employmentForms,
    ])
  }

  const deleteEmployment = (index) => {
    const updated = [...employmentForms]
    updated.splice(index, 1)
    syncEmploymentHistory(updated)
  }

  return (
    <Form.Field required>
      <label>Experience</label>
      <Segment>
        <Grid container>
          <Grid.Row>
            <Grid.Column>
              <Grid>
                {employmentForms.map((employment, index) => (
                  <Grid.Row key={employment.id}>
                    <Grid.Column width={1} verticalAlign="middle">
                      <Form.Button
                        circular
                        basic
                        icon="trash"
                        onClick={() => deleteEmployment(index)}
                      />
                    </Grid.Column>
                    <Grid.Column width={15}>
                      <Employment
                        employment={employment}
                        onChange={(updatedEmployment) =>
                          updateEmploymentAtIndex(index, updatedEmployment)
                        }
                      />
                      <Divider />
                    </Grid.Column>
                  </Grid.Row>
                ))}
              </Grid>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <Form.Button primary content="Add More" onClick={addEmployment} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </Form.Field>
  )
}

export default EmploymentHistory
